// extracted by mini-css-extract-plugin
module.exports = {"credits":"Credits_credits__1XV9W","title":"Credits_title__3oNyE"};